import type { AuthRepository } from "../repositories/auth-repository"

export const makeLogin = (repo: AuthRepository) =>
  async (credentials: { email: string; password: string }) =>
    repo.login(credentials)
